import React from "react";
import "./App.css";
import About from "./pages/About/About";
import { Link, Route, Routes } from "react-router-dom";

function App() {
  return (
    <>
    <div>
    <About/>
    </div>
    </>
  );
}

export default App;
